import React from 'react'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import withHandlers from 'recompose/withHandlers'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import play from 'public/assets/svg/positional_media/play_i.svg'
import pause from 'public/assets/svg/positional_media/pause_i.svg'
import replay from 'public/assets/svg/positional_media/replay_i.svg'

const style = theme => ({
    wrapper: {
        width: 75,
        height: 47,
        position: 'relative',
        cursor: 'pointer',
        '&:hover': {
            '& div.trans-background': {
                opacity: 0.7,
            },
            '& img': {
                transform: state =>
                    state === 'play' ? 'translateY(-50%) translateX(-35%)' : 'translateY(-50%) translateX(-50%)',
            },
        },
    },
    border: {
        border: '1.8px solid #fff',
        width: 'calc(100% + 2px)',
        height: 'calc(100% + 2px)',
        borderRadius: 4,
        position: 'absolute',
        boxSizing: 'border-box',
        top: -1,
        left: -1,
        // transform: 'translateY(-100%)',
    },
    borderBlur: {
        width: 'calc(100% + 4px)',
        height: 'calc(100% + 4px)',
        borderRadius: 4,
        position: 'absolute',
        filter: 'blur(3px)',
        boxSizing: 'border-box',
        top: -2,
        left: -2,
        // transform: 'translateY(-100%)',
    },
    background: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        backgroundColor: '#000',
        opacity: 0.5,
        borderRadius: 4,
        transition: '0.18s',
        transitionTimingFunction: 'ease-out',
    },
    iconContainer: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        zIndex: 1,
    },
    icons: {
        position: 'relative',
    },
    icon: {
        color: '#fff',
        fontSize: 28,
        position: 'absolute',
        transform: state =>
            state === 'play'
                ? 'translateY(-50%) translateX(-35%) scale(0.9)'
                : 'translateY(-50%) translateX(-50%) scale(0.9)',
        top: 0,
        left: 0,
        transition: '.18s',
        transitionTimingFunction: 'ease-out',
    },
    iconBlur: {
        color: '#fff',
        fontSize: 28,
        filter: 'blur(3px)',
        position: 'absolute',
        transform: state =>
            state === 'play'
                ? 'translateY(-50%) translateX(-35%) scale(0.9)'
                : 'translateY(-50%) translateX(-50%) scale(0.9)',
        top: 0,
        left: 0,
        transition: '.18s',
        transitionTimingFunction: 'ease-out',
    },
    progressBarContainer: {
        width: '100%',
        height: 4,
        position: 'absolute',
        transform: 'translateY(-100%)',
        zIndex: 1,
    },
    progressBar: {
        backgroundColor: '#fff',
        width: ({ progress }) => `${progress * 100}%`,
        maxWidth: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
    },
    progressBarBlur: {
        backgroundColor: '#fff',
        width: ({ progress }) => `${progress * 100}%`,
        maxWidth: '100%',
        height: '100%',
        filter: 'blur(2px)',
        position: 'absolute',
        top: 0,
        left: 0,
    },
})

const MEDIA_STATES = {
    play,
    pause,
    replay,
}

const handlers = withHandlers({
    handleClick: ({ state, progress, onClick }) => event => onClick && onClick(event, { state, progress }),
})

const MediaButton = ({ classes, state, handleClick }) => {
    let imgIcon
    switch (state) {
        case 'play':
            imgIcon = 'pause'
            break
        case 'pause':
            imgIcon = 'play'
            break
        default:
            imgIcon = 'replay'
    }
    return (
        <div className={classNames('media-button', classes.wrapper)} onClick={handleClick}>
            <div className={classes.iconContainer}>
                <div className={classes.icons}>
                    <img alt={`${imgIcon}_blurred`} className={classes.iconBlur} src={MEDIA_STATES[imgIcon]} />
                    <img alt={imgIcon} className={classes.icon} src={MEDIA_STATES[imgIcon]} />
                </div>
            </div>
            <div className={classes.progressBarContainer}>
                <div className={classes.progressBarBlur} />
                <div className={classes.progressBar} />
            </div>
            <div className={classNames(classes.background, 'trans-background')} />
            <div className={classes.borderBlur} />
            <div className={classes.border} />
        </div>
    )
}

MediaButton.defaultProps = {
    state: 'pause',
    progress: 0.5,
    onClick: () => null,
}

export default compose(injectSheet(style), handlers, pure)(MediaButton)
